export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13980.e5ba3728.jpg";